/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders, HttpParams
} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

@Injectable()
export class ManagerCompanySettingsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  getSettingsResponse(): Observable<HttpResponse<any>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;

    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/company-settings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  getSettings(): Observable<any> {
    return this.getSettingsResponse().pipe(map(_r => _r.body));
  }

  updateSettingResponse(key: string, value: any[]): Observable<HttpResponse<any>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = { value: value };

    const req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/manager/company-settings/` + encodeURIComponent(key),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  updateSetting(key: string, value: any[]): Observable<any> {
    return this.updateSettingResponse(key, value).pipe(map(_r => _r.body));
  }
}
